// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-footer.footer{background:#242424!important;padding:0;width:100%}.v-footer.footer .container{display:flex;gap:0 3rem}.v-footer.footer a{color:hsla(0,0%,100%,.8)!important;font-size:.9rem;font-weight:500;-webkit-text-decoration:none;text-decoration:none;transition:.2s cubic-bezier(0,0,.2,1)}.v-footer.footer a:hover{color:#fff!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
